import Queue from "nq-js";

class ResetPasswordUseCase {
  constructor() {}

  execute(email, options) {
    return new Queue.User().resetPassword(email, options);
  }
}

export default ResetPasswordUseCase;
